import React from 'react'
import { MealPlanStepper } from '../MealPlanStepper'
import { MealPlanHeaderRoot, StepperContainer, Wrapper } from './MealPlanHeader.styles'

type MealPlanHeaderProps = {}

export const MealPlanHeader = (_props: MealPlanHeaderProps) => {

  return (
    <MealPlanHeaderRoot>
      <Wrapper>
        <StepperContainer>
          <MealPlanStepper />
        </StepperContainer>
      </Wrapper>
    </MealPlanHeaderRoot>
  )
}

MealPlanHeader.displayName = 'MealPlanHeader'
